// extracted by mini-css-extract-plugin
export default {"actions":"StudioName_actions__BIMVa"};